import React, { useEffect, useState } from "react";
import { Overview } from "./components/Overview";
import { PaymentPlan } from "./components/PaymentPlan";
import "./financial.css";
import { ObligationManagement } from "./components/ObligationManagement";
import { Transactions } from "./components/Transactions";
import { handleGetLocal } from "../../../../services/auth-service";
import axios from "axios";
import { LoadPanel } from "devextreme-react";
import { Toster } from "../../../../components/Toster/Toster";
import { useNavigate, useParams } from "react-router-dom";
import { logOut } from "../../../../components/Logout";
import ObligationDetail from "./components/ObligationDetail";
import { saveTabState } from "../../../../reducer/tabStateSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import MonitoringPeriods from "./components/MonitoringPeriods";

export const Financial = ({
  load,
  userinfo,
  setOverviewData,
  callApi,
  setCallApi,
  overviewData,
  setLoad,
  OverviewList,
  reloadUserInfo,
}) => {
  const idd = useParams();
  const dispatch = useDispatch();
  const cachedUserData = useSelector((state) => state.tabState.tabs[idd?.id]);
  const [activeTab, setActiveTab] = useState(cachedUserData?.finTab ? cachedUserData?.finTab : "tab1");
  const [financialStatus, setFinancialStatus] = useState([]);
  const [listData, setListData] = useState([]);
  const [paymnetMethodData, setPaymnetMethodData] = useState([]);
  const [reasonListData, setReasonListData] = useState([]);
  const [isMonitoringVisible, setIsMonitoringVisible] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const navigate = useNavigate();
  const pathname = handleGetLocal("pathURL");

  const monitoringVisible = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Account/getCompanyOption?Name=EM Enabled`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        }
      );
      setIsMonitoringVisible(response?.data?.data.trim().toLowerCase() === "true");

    } catch (error) {
      console.error("Error fetching EM Enabled option:", error);
    }
  }

  const getDetailList = async () => {
    setLoad(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/Payment/masterDropDownValuesGet`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        setLoad(false);
        setListData(val?.data?.data?.cashDrawer);
        setPaymnetMethodData(val?.data?.data?.paymentType);
        val.data.data.financialStatus = [
          ...val?.data?.data?.financialStatus,
          {
            key: "00000000-0000-0000-0000-000000000000",
            value: "-do not change-",
          },
        ];
        setReasonListData(val?.data?.data?.reason);
        setFinancialStatus(val?.data?.data?.financialStatus);
      })
      .catch((val) => {
        setLoad(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  };

  useEffect(() => {
    getDetailList();
    OverviewList();
    monitoringVisible();
    if (cachedUserData?.finTab) setActiveTab(cachedUserData?.finTab);
    else dispatch(saveTabState({ tabId: idd?.id, data: userinfo, tab: 2, finTab: "tab1" }));
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    dispatch(saveTabState({ tabId: idd?.id, data: userinfo, tab: 2, finTab: tab }));
  };

  return (
    <>
      <LoadPanel shadingColor="true" visible={load} delay={10} />
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
      <div className="financial_tab">
        <div className="financial_tab_nav">
          <button
            className={
              activeTab === "tab1" ? "financial_tab_active financial_tab_nav_button" : "financial_tab_nav_button"
            }
            onClick={() => handleTabClick("tab1")}
          >
            Payments
          </button>
          <button
            className={
              activeTab === "tab2" ? "financial_tab_active financial_tab_nav_button" : "financial_tab_nav_button"
            }
            onClick={() => handleTabClick("tab2")}
          >
            Payment Plan
          </button>
          <button
            className={
              activeTab === "tab3" ? "financial_tab_active financial_tab_nav_button" : "financial_tab_nav_button"
            }
            onClick={() => handleTabClick("tab3")}
          >
            Obligation Management
          </button>
          <button
            className={
              activeTab === "tab4" ? "financial_tab_active financial_tab_nav_button" : "financial_tab_nav_button"
            }
            onClick={() => handleTabClick("tab4")}
          >
            Transactions
          </button>
          <button
            className={
              activeTab === "tab5" ? "financial_tab_active financial_tab_nav_button" : "financial_tab_nav_button"
            }
            onClick={() => handleTabClick("tab5")}
          >
            Obligation Detail
          </button>
          {isMonitoringVisible && <button
            className={
              activeTab === "tab6" ? "financial_tab_active financial_tab_nav_button" : "financial_tab_nav_button"
            }
            onClick={() => handleTabClick("tab6")}
          >
            Monitoring Periods
          </button>}

        </div>
        <div className="financial_tab_data">
          {activeTab === "tab1" && (
            <Overview
              setOverviewData={setOverviewData}
              overviewData={overviewData}
              setCallApi={setCallApi}
              callApi={callApi}
              userinfo={userinfo}
              paymnetMethodData={paymnetMethodData}
              setPaymnetMethodData={setPaymnetMethodData}
              listData={listData}
              setListData={setListData}
              toastConfig={toastConfig}
              setToastConfig={setToastConfig}
              reloadUserInfo={reloadUserInfo}
              OverviewList={OverviewList}
            />
          )}
          {activeTab === "tab2" && <PaymentPlan userinfo={userinfo} />}
          {activeTab === "tab3" && (
            <ObligationManagement
              userinfo={userinfo}
              reasonListData={reasonListData}
              financialStatus={financialStatus}
              toastConfig={toastConfig}
              setToastConfig={setToastConfig}
            />
          )}
          {activeTab === "tab4" && <Transactions userinfo={userinfo} />}
          {activeTab === "tab5" && <ObligationDetail userinfo={userinfo} />}
          {activeTab === "tab6" && <MonitoringPeriods userinfo={userinfo} />}
        </div>
      </div>
    </>
  );
};
